import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { Breadcrumb } from 'semantic-ui-react'

const pathMenu = (props) => {
  return (
    <Breadcrumb size='large'>
      <Breadcrumb.Section><Link to='/' style={{ color: 'black' }}><b>Home</b></Link></Breadcrumb.Section>
      {props.link && props.link.map((el, i) =>
        <span key={i}>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active={i === props.link.length}>
            {i === props.link.length
              ? <Link style={{ color: 'black' }} key={i} to={el.toLowerCase()}><b>{el}</b></Link>
              : <b>{el}</b>}
          </Breadcrumb.Section>
        </span>
      )}
    </Breadcrumb>
  )
}

pathMenu.propTypes = {
  link: PropTypes.array
}

export default pathMenu



// WEBPACK FOOTER //
// ./src/layouts/Layout/PathMenu/PathMenu.js